<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row class="mt-3"><b-col><h1>Marketing → Referidos</h1></b-col></b-row>

      <b-card class="mb-3" title="Parámetros del programa">
        <b-row>
          <b-col md="3"><b-form-group label="Puntos al referidor"><b-form-input type="number" v-model.number="cfg.points"></b-form-input></b-form-group></b-col>
          <b-col md="3"><b-form-group label="Beneficio al referido (código)"><b-form-input v-model="cfg.referred_reward_definition"></b-form-input></b-form-group></b-col>
          <b-col md="3"><b-form-group label="Liberación"><b-form-input v-model="cfg.release_on"></b-form-input></b-form-group></b-col>
          <b-col md="3"><b-form-group label="Solo clientes nuevos"><b-form-checkbox v-model="cfg.only_new_customers" switch></b-form-checkbox></b-form-group></b-col>
        </b-row>
        <b-form-checkbox v-model="cfg.block_same_phone" switch>Antifraude: bloquear mismo teléfono/email</b-form-checkbox>
        <b-button class="mt-2" variant="primary" @click="saveConfig">Guardar parámetros</b-button>
      </b-card>

      <b-row>
        <b-col md="8">
          <h5>Referidos</h5>
          <b-form-select v-model="statusFilter" :options="statusOptions" @change="load" style="max-width:220px;"></b-form-select>
          <b-table small striped responsive :items="referrals" :fields="fields" :busy="loading" class="mt-2">
            <template #cell(status)="data">
              <b-badge :variant="statusVariant(data.item.status)">{{ data.item.status }}</b-badge>
              <small v-if="data.item.reject_reason" class="text-muted"> ({{ reasonText(data.item.reject_reason) }})</small>
            </template>
            <template #cell(buttons)="data">
              <b-button size="sm" variant="outline-danger" v-if="data.item.status==='pending'" @click="reject(data.item)">Rechazar</b-button>
            </template>
          </b-table>
        </b-col>
        <b-col md="4">
          <h5>Top referidores</h5>
          <b-table small striped :items="topReferrers" :fields="topFields"></b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Nav from "../../components/Nav.vue";
import marketingService from "../../services/marketingService";
import featuresService from "../../services/featuresService";

export default {
  name: "referidos",
  components: { Nav },
  data() {
    return {
      referrals: [],
      topReferrers: [],
      loading: false,
      statusFilter: "",
      cfg: { points: 100, referred_reward_definition: "REFERRAL_FREE_SHIPPING", release_on: "first_purchase", only_new_customers: true, block_same_phone: true },
      rawConfig: {},
      statusOptions: [
        { value: "", text: "Todos" },
        { value: "pending", text: "Pendientes" },
        { value: "rewarded", text: "Recompensados" },
        { value: "rejected", text: "Rechazados" },
      ],
      fields: [
        { key: "referrer_name", label: "Referidor" },
        { key: "referred_name", label: "Referido" },
        { key: "code_used", label: "Código" },
        { key: "status", label: "Estado" },
        { key: "registered_at", label: "Registrado" },
        { key: "buttons", label: "" },
      ],
      topFields: [
        { key: "name", label: "Cliente" },
        { key: "rewarded_count", label: "Referidos" },
      ],
    };
  },
  mounted() {
    this.load();
    this.loadConfig();
  },
  methods: {
    load() {
      this.loading = true;
      marketingService.listReferrals(this.statusFilter)
        .then((res) => { this.referrals = res.data.referrals || []; this.topReferrers = res.data.top_referrers || []; })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"))
        .finally(() => (this.loading = false));
    },
    loadConfig() {
      featuresService.getAll().then((res) => {
        const f = res.data && res.data.features && res.data.features["referrals"];
        if (f && f.config) {
          this.rawConfig = f.config;
          const rr = f.config.referrer_reward || {};
          this.cfg.points = rr.points != null ? rr.points : 100;
          this.cfg.referred_reward_definition = f.config.referred_reward_definition || "REFERRAL_FREE_SHIPPING";
          this.cfg.release_on = f.config.release_on || "first_purchase";
          this.cfg.only_new_customers = f.config.only_new_customers !== false;
          const af = f.config.antifraud || {};
          this.cfg.block_same_phone = af.block_same_phone !== false;
        }
      }).catch(() => {});
    },
    saveConfig() {
      const config = {
        ...this.rawConfig,
        referrer_reward: { ...(this.rawConfig.referrer_reward || {}), type: "bonus_points", points: this.cfg.points, counts_for_tier: false },
        referred_reward_definition: this.cfg.referred_reward_definition,
        release_on: this.cfg.release_on,
        only_new_customers: this.cfg.only_new_customers,
        antifraud: { ...(this.rawConfig.antifraud || {}), block_same_phone: this.cfg.block_same_phone },
      };
      featuresService.update("referrals", { enabled: true, config })
        .then(() => this.makeToast("Guardado", "Parámetros actualizados", "success"))
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    reject(r) {
      marketingService.rejectReferral(r.id, "manual")
        .then(() => { this.load(); this.makeToast("Listo", "Referido rechazado", "success"); })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    statusVariant(s) {
      return { pending: "info", rewarded: "success", rejected: "danger" }[s] || "secondary";
    },
    reasonText(r) {
      return { self_referral: "auto-referido", duplicate_phone: "teléfono/email duplicado", not_new: "no es nuevo", manual: "manual" }[r] || r;
    },
    errMsg(err) {
      if (err && err.response && err.response.data) {
        return typeof err.response.data === "string" ? err.response.data : (err.response.data.error || JSON.stringify(err.response.data));
      }
      return err && err.message ? err.message : "Error desconocido";
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, { title, variant, autoHideDelay: 5000, appendToast: true });
    },
  },
};
</script>
